<template>
  <div id="app">
    <!-- <img src="./assets/logo.png"> -->
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  height: 100%;
  max-width: 10rem /* 640/64 */;
  margin: 0 auto;
  position: relative;
  overflow-x: hidden;
}


.zoom-fade-enter-active {
  transition: all 0.3s ease;
}
.zoom-fade-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}
.zoom-fade-enter {
  /* transform: translateX(100%); */
  transform: scale(0);
  opacity: 0;
}

.zoom-fade-leave-to{
  transform: scale(2);
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue